module.exports = __webpack_public_path__ + "img/countdown-bg.0a137301.png";